import React from "react";
const contentBlocks = [{
  heading: "Revitalizing Startup Through Major Deals & Investment",
  paragraphs: [],
  image: "https://newmavericks.com/wp-content/uploads/2026/04/James-2-copy.jpg?v=pvr8vrlfj8o"
}, {
  heading: "Revitalizing Startup Through Major Deals & Investment",
  paragraphs: [],
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1524742/img/digital_experience_design.png"
}, {
  heading: "Strategic Brand Identity",
  paragraphs: [],
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1524742/img/strategic_brand_identity.png"
}, {
  heading: "Client-Centric Collaboration",
  paragraphs: [],
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1524742/img/client_collaboration_partnership.png"
}];
export default function TextContentBlocks() {
  return;
}